import { render, staticRenderFns } from "./SkuList.vue?vue&type=template&id=2efca573&"
import script from "./SkuList.vue?vue&type=script&lang=js&"
export * from "./SkuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports